module.exports = __webpack_public_path__ + "static/media/warning-outline.34031e84.svg";